module.exports = __webpack_public_path__ + "img/C07TechEyeOfOdin_ua.befae508.webp";